import { Action, createReducer, on } from '@ngrx/store';
import * as suricataActions from './suricata.action';
import { SuricataReducer } from '../suricata.model';

const initialState: SuricataReducer = {
  suricataConfiguration: {},
};

const reducer = createReducer(
  initialState,
  on(suricataActions.setSuricataConfiguration, (state, props) => ({
    ...state,
    suricataConfiguration: props.suricataConfiguration,
  })),

  on(suricataActions.updateSuricataConfiguration, (state, props) => ({
    ...state,
    suricataConfiguration: {
      ...state.suricataConfiguration,
      ...props.updatedSuricataConfig,
      enable_suricata_configuration: state.suricataConfiguration.enable_suricata_configuration,
    },
  })),

  on(suricataActions.setIdsDeviceLevelEnabledState, (state, props) => ({
    ...state,
    suricataConfiguration: {
      ...state.suricataConfiguration,
      enable_suricata_configuration: props.updatedIdsState,
    },
  })),

  on(suricataActions.clearSuricataConfiguration, () => initialState)
);

export function suricataReducer(state: SuricataReducer | undefined, action: Action) {
  return reducer(state, action);
}
